const langPackLocalVersion = 4;export default langPackLocalVersion;
